import { render } from "./ResolutionFilter.vue?vue&type=template&id=73e45a91&scoped=true"
import script from "./ResolutionFilter.vue?vue&type=script&lang=js"
export * from "./ResolutionFilter.vue?vue&type=script&lang=js"

import "./ResolutionFilter.vue?vue&type=style&index=0&id=73e45a91&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73e45a91"]])

export default __exports__